<template>
  <div class="box">
    <div class="title">
      <img class="icon" src="../../assets/icon/dfk.png" /><span class="txt"
        >请选择支付方式</span
      >
    </div>
    <div class="pay-bg">
      <img src="../../assets/images/pay.png" class="pay" />
    </div>
    <div class="bank-no">
      银行卡号:<input type="text" placeholder="请输入银行卡号" />
    </div>
    <el-button  class="fr" type="primary" @click="pay">支 付</el-button>
  </div>
</template>
<script>
import { button } from "element-ui";
export default {
  components: {
    elButton: button,
  },
  methods: {
    pay() {
        this.$router.push({ path: "shoppingCar" });
    },
  },
};
</script>
<style scoped>
.box {
  padding-left: 100px;
}
.title {
  height: 50px;
  margin-top: 100px;
  border-bottom: 1px solid #dddfe3;
  margin-bottom: 20px;
}
.icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.txt {
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 20px;
  vertical-align: middle;
}
.pay-bg {
  background-color: #fff;
}
.pay {
  width: 900px;
  height: 300px;
  cursor: pointer;
}
.bank-no {
  margin-top: 20px;
}
input {
  width: 400px;
  height: 35px;
  background: #f5f5f5;
  border: 1px solid #dddfe3;
}
.fr{
    display:flex;
    justify-content: flex-end;
    margin-right:50px;
}
</style>


// WEBPACK FOOTER //
// src/pages/pay/pay.vue